module.exports = __webpack_public_path__ + "img/DSC_2847.97742dc7.png";